import React from "react";

import styled from "styled-components";
import { media } from "./_includes/Device";

import CV from "../assets/images/cv.png";
import Phone from "../assets/images/phone.png";
import Test from "../assets/images/test.png";
import Interviews from "../assets/images/interviews.png";
import Onsite from "../assets/images/onsite.png";
import Hired from "../assets/images/hired.png";

const ProcessWrapper = styled.div`
  background-color: #07bd72;
  border-radius: 15px;
  color: white;
  padding: 40px;

  h2,
  p {
    color: white;
  }

  ul {
    list-style: none;
    padding: 0;
    position: relative;

    &:before {
      content: "";
      left: 9px;
      top: 5px;
      bottom: 5px;
      height: auto;
      width: 1px;
      transform: translateX(-50%);
      background-color: white;
      position: absolute;
    }

    li {
      position: relative;
      padding-left: 65px;
      color: white;
      margin-bottom: 20px;

      img {
        top: 50%;
        transform: translateY(-50%);
        width: 28px;
        height: auto;
        position: absolute;
        left: 28px;
      }

      &.highlight {
        &:after {
          transform: translateY(-50%) scale(1.25);
        }
      }

      &:after {
        content: "";
        width: 10px;
        height: 10px;
        background-color: #07bd72;
        border: 4px solid white;
        border-radius: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        transform-origin: center;
        transition: transform 0.2s ease-in-out;
      }
    }
  }

  ${media.tablet`
    padding: 20px;
  `}
`;

export class ApplicationProcess extends React.Component {
  render() {
    return (
      <div>
        <ProcessWrapper>
          <h2>Process</h2>
          <ul>
            <li>
              <img src={CV} alt="icon" />
              CV screening
            </li>
            <li>
              <img src={Phone} alt="icon" />
              Phone conversation
            </li>
            <li>
              <img src={Test} alt="icon" />
              Online test*
            </li>
            <li>
              <img src={Interviews} alt="icon" />
              Interviews
            </li>
            <li>
              <img src={Onsite} alt="icon" />
              On-site day*
            </li>
            <li>
              <img src={Hired} alt="icon" />
              Hired
            </li>
          </ul>

          <p>* Depending on the role</p>
        </ProcessWrapper>
      </div>
    );
  }
}
